module.exports = __webpack_public_path__ + "static/media/bitmap-p-p-3@1x.3cfc307c.png";